import { Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ShareDeviceService, CachedDataService } from '@services';

import { ShareRequest, ObservableObject } from "@models";

import {  } from "@models";
@Component({
  selector: 'app-share-requests',
  templateUrl: './share-requests.component.html'
})

export class ShareRequestsComponent implements OnInit, OnDestroy {
  shareRequestsList = null;
  ifLoading = true;

  curentUser;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('shareDeviceConfirm') shareDeviceConfirm;
  @ViewChild('shareDeviceCancel') shareDeviceCancel;
  

  constructor(private shareDeviceService: ShareDeviceService, private cachedDataService: CachedDataService){
    this.curentUser = this.cachedDataService.getCurrentUser();

    this.shareDeviceService.updateRequestsObservable
    .takeUntil(this.ngUnsubscribe)
    .subscribe(respone => {
	  this.getShareDevice();
    });
  }

  ngOnInit(){
	  this.getShareDevice();
	  
  }
  getShareDevice(){
    this.shareDeviceService.getShareDevice()
      .subscribe(response => {
        if(response && response.length){
          this.shareRequestsList = response.filter(item=>item.status.toLowerCase()=="sent")
        }else{
          this.shareRequestsList = null;
        }
        this.ifLoading = false;
      },
        error => {
            this.ifLoading = false;
          console.log(error);
        }
      );
  }

  openConfirmShare(request: ShareRequest){
    this.shareDeviceConfirm.open(request);
  }
  openCancelShare(request: ShareRequest){
    this.shareDeviceCancel.open(request);
  }
  
 
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}




// WEBPACK FOOTER //
// ./src/app/view/share-requests/share-requests.component.ts